import { useLeagueFilterContext } from '../contexts/league-filter-context';

export const useLeagueFilter = () => {
	const { tempSelectedLeagues, ...props } = useLeagueFilterContext();

	const tempLeagueSelection = tempSelectedLeagues.filter(item => item.checked);

	return {
		tempSelectedLeagues,
		tempLeagueSelection,
		...props
	};
};